import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { useServicesContext } from '../../../../../context';
import { GenericButton } from '../buttons/GenericButton';
import { useButtons } from '../../../../../components/buttons/useButtons';
import { getCashCheckout, getLeanCheckoutPayload, isGroupLeanCashCheckoutButton, isGroupLeanCheckoutButton, isGroupLeanFinancingCheckoutButton, } from '../../../../../utils';
import { trackGroupLeanCheckoutClick } from '../../../../../components';
import { dynamicStylingHelper } from '../../../../utils/AlphaHelper';
const FinanceRethinkCTAs = ({ vehicle, selectedModality, useFinanceData, isLoading, fsagRequest, hasWebCalcErrors, isMobileScreenSize, trackButtonClick, }) => {
    var _a;
    const logger = ((_a = useServicesContext().getAdditionalService('s2:logger')) !== null && _a !== void 0 ? _a : console);
    const layerManager = useServicesContext().getAdditionalService('gfa:layer-manager');
    const configurationService = useServicesContext().getAdditionalService('vtp-configuration-service');
    const navigationService = useServicesContext().getAdditionalService('navigation-service');
    const eCommerceService = useServicesContext().getAdditionalService('e-commerce-service');
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const environmentConfig = useServicesContext().getEnvironmentConfig();
    const { financeButtonsState, scContextId, phoneWithNumber } = useButtons(vehicle, 'pdp', selectedModality, useFinanceData, configurationService, environmentConfig, false, false);
    const filteredButtons = financeButtonsState.filter((cta) => cta.showButtonInLayer);
    return (React.createElement(React.Fragment, null, filteredButtons.map((button, index) => {
        const variant = index === 0 ? 'primary' : 'secondary';
        const isGlcButton = isGroupLeanCheckoutButton(button);
        let checkoutBackend;
        let leanCheckoutClick;
        if (isGlcButton) {
            if (isGroupLeanCashCheckoutButton(button)) {
                checkoutBackend = getCashCheckout(vehicle);
            }
            else {
                checkoutBackend = getLeanCheckoutPayload(vehicle, fsagRequest, isGroupLeanFinancingCheckoutButton(button), true);
            }
            if (checkoutBackend) {
                leanCheckoutClick = (checkout) => {
                    try {
                        trackGroupLeanCheckoutClick(trackingService, navigationService, button, variant, 'vtp-carInfo', vehicle, logger);
                        eCommerceService.startCheckout(checkout);
                    }
                    catch (e) {
                        logger.error(JSON.stringify(e));
                    }
                };
                return (React.createElement(TextButton, { "aria-label": button.label, key: button.label, variant: variant, isFullWidth: isMobileScreenSize, onClick: () => {
                        leanCheckoutClick(checkoutBackend);
                    }, disabled: hasWebCalcErrors, size: dynamicStylingHelper('md', 'sm'), isLoading: isLoading }, button.label));
            }
            return null;
        }
        return (React.createElement(GenericButton, { key: `Button-vehicle-${vehicle.id}`, vehicle: vehicle, buttonInfo: button, appContext: "carinfo", useFinanceData: Boolean(true), variant: variant, "data-testId": `standard-button-${variant}`, layerManager: layerManager, scContextId: scContextId, phoneWithNumber: phoneWithNumber, configurationService: configurationService, trackButtonClick: trackButtonClick, isMobileScreenSize: isMobileScreenSize, isLoading: isLoading, showAsText: false }));
    })));
};
export default FinanceRethinkCTAs;
